import { HttpService } from './../http.service';
import { AuthenticationService } from './../authentication/authentication.service';
import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  login_form: FormGroup;
  isSubmitted = false;

  constructor(private formBuilder: FormBuilder, private http: HttpService) {
  // constructor(private formBuilder: FormBuilder, private authenticationService: AuthenticationService, private http: HttpService) {
    this.login_form = this.formBuilder.group({
      user_name: [null, Validators.required],
      password: [null, Validators.required],
    });
    setTimeout(() => document.getElementById('user_name').focus(), 500);
  }
  get formControls() { return this.login_form.controls; }

  focusToPassword() {
    document.getElementById('password').focus()

  }

  logIn() {
    console.log('login function');
    console.log(this.login_form.value);
    if (this.login_form.invalid) {
      return;
    }
    this.http.login(this.login_form.value);
  }
}

